/** App primary palette (see `src/styles/_variables.scss`, `CustomButtons/style.css`). */
export const PAYOUT_PRIMARY_CSS = {
  primary: "var(--color-blue-2)",
  primaryHover: "var(--color-blue-3)",
};

/** Pricing side for payout + payout analysis APIs (`side` query param). */
export const PAYOUT_PRICING_SIDES = {
  BID: "bid",
  ASK: "ask",
};

export const PAYOUT_PRICING_SIDE_DEFAULT = PAYOUT_PRICING_SIDES.BID;

export function normalizePayoutPricingSide(
  side,
  fallback = PAYOUT_PRICING_SIDE_DEFAULT
) {
  const normalized = String(side ?? "").trim().toLowerCase();
  if (normalized === PAYOUT_PRICING_SIDES.ASK) {
    return PAYOUT_PRICING_SIDES.ASK;
  }
  if (normalized === PAYOUT_PRICING_SIDES.BID) {
    return PAYOUT_PRICING_SIDES.BID;
  }
  return fallback;
}
